import React, { useEffect, useRef } from "react";
import { SkyTvChecked, SkyTvUnchecked } from "./icon";
import { Field, Form } from "react-jeff";

export interface T_RadioButtonOption {
  value: string;
  label: string;
}

interface RadioButtonGrpProps {
  options: T_RadioButtonOption | T_RadioButtonOption[];
  onSelect: (value: string) => void;
  selectedOption?: string;
  className?: string;
  fieldValidation?: Field<any, string>;
  formValidation?: Form<string>
  id?: string;
}

const RadioButtonGroup: React.FC<RadioButtonGrpProps> = ({
  options,
  onSelect,
  selectedOption,
  fieldValidation,
  formValidation,
  id,
  ...props
}) => {
  const firstRadioRef = useRef<HTMLInputElement>(null);
  const errorPresent = fieldValidation ? fieldValidation.errors.length > 0 : false;

  useEffect(() => {
    if (errorPresent && firstRadioRef.current) {
      firstRadioRef.current.focus();
    }
  }, [errorPresent]);

  const optionList = Array.isArray(options) ? options : [options];
  const wrapperClass = "flex flex-col gap-1";

  return (
    <div className={wrapperClass}>
      <fieldset className="flex gap-2">
        {optionList.map(({ value, label }, index) => (
          <label
            key={`RadioButtonGroup-${index}`}
            className="flex flex-row items-center gap-2 cursor-pointer"
          >
            <input
              type="radio"
              id={id}
              {...props}
              checked={selectedOption === value}
              onChange={() => onSelect(value)}
              className="sr-only"
              ref={index === 0 ? firstRadioRef : null}
            />
            {selectedOption === value ? <SkyTvChecked /> : <SkyTvUnchecked />}
            <span className="sky-h6-reg text-primary-mid-night">{label}</span>
          </label>
        ))}
      </fieldset>
      {errorPresent && (
        <p className="text-error">{fieldValidation?.errors[0]}</p>
      )}
    </div>
  );
};

export { RadioButtonGroup };